import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";
import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import moment from 'moment';
import {DateRangePicker} from "react-bootstrap-daterangepicker";
import lodash from "lodash";
import withReactContent from "sweetalert2-react-content";
import swal from "sweetalert2";
import {disableLoading, enableLoading} from "../../../../features/loading/loadingSlice";
import UpdateMaintenance from "../../../../queries/Devices/UpdateMaintenance";
import GetDevice from "../../../../queries/Devices/GetDevice";
import './StatusBadge.css';
import './MaintenanceModal.css';


export default function MaintenanceModal(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startDateWarranty, setStartDateWarranty] = useState(null);
    const [endDateWarranty, setEndDateWarranty] = useState(null);
    const [invoiceDue, setInvoiceDue] = useState(null);
    const [installationDate, setInstallationDate] = useState(null);
    const [serialNumber, setSerialNumber] = useState('');
    const [routerInfo, setRouterInfo] = useState('');
    const [amount, setAmount] = useState(0);
    const [parentMaintenance, setParentMaintenance] = useState(null);
    const [parentMaintenanceId, setParentMaintenanceId] = useState(null);
    const [disableMaintenance, setDisableMaintenance] = useState(false);
    const [currentUser] = useState(props.currentUser);
    const [currentGroup] = useState(props.currentGroup);
    const [confirmation, setConfirmation] = useState(false);
    const confirmationMessage = withReactContent(swal);
    const errorMessage = withReactContent(swal);

    const badgeClassForStatus = (status) => {
        if (status === t("Active")) return "status-badge status-badge-success";
        if (status === t("Extended")) return "status-badge status-badge-info";
        if (status === t("Expiring")) return "status-badge status-badge-warning";
        return "status-badge status-badge-danger";
    };

    const formatDate = (date) => {
        if (!date)
            return "-";

        return date.format("DD.MM.YYYY");
    };

    const formatDateRange = (a, b) => {
        let aString = formatDate(a);
        let bString = formatDate(b);

        return `${aString} - ${bString}`;
    };

    const handleInvoiceAmountChange = (e) => {
        setAmount(Number(e.target.value));
    }

    const handleSerialNumberChange = (e) => {
        setSerialNumber(e.target.value);
    }

    const handleRouterInfoChange = (e) => {
        setRouterInfo(e.target.value);
    }

    // `refresh` tells the parent whether the device list actually needs
    // refetching — only true when a save/disable/enable actually changed
    // something; a plain Close shouldn't trigger a background refetch.
    const cleanAndCloseModal = (close = true, cleanParent = true, refresh = false) => {
        setStartDate(null);
        setEndDate(null);
        setStartDateWarranty(null);
        setEndDateWarranty(null);
        setInvoiceDue(null);
        setInstallationDate(null);
        setSerialNumber('');
        setRouterInfo('');
        setAmount(0);
        if(cleanParent) {
            setParentMaintenance(null);
            setParentMaintenanceId(null);
        }
        if(close) {
            props.hideFn(refresh);
        }
    }

    const handleCallback = (startDate, endDate) => {
        startDate = moment(startDate);
        endDate = moment(endDate);
        setStartDate(startDate);
        setEndDate(endDate);
    }

    const handleCallbackWarranty = (startDate, endDate) => {
        startDate = moment(startDate);
        endDate = moment(endDate);
        setStartDateWarranty(startDate);
        setEndDateWarranty(endDate);
    }

    const handleCallbackDue = (startDate) => {
        startDate = moment(startDate);
        setInvoiceDue(startDate);
    }

    const handleCallbackInstallation = (startDate) => {
        startDate = moment(startDate);
        setInstallationDate(startDate);
    }

    const handleParentChange = async (e) => {
        const parent = Number(e.target.value) === 0 ? null : Number(e.target.value);
        setParentMaintenanceId(parent);
        if(parent === null) {
            return;
        }

        const selected = props.selectedDevice || {};
        GetDevice(parent, currentGroup.id).then((response) => {
            const data = response.data.data;
            cleanAndCloseModal(false, false);
            setStartDate(data.period_start ? moment(data.period_start) : null);
            setEndDate(data.period_end ? moment(data.period_end) : null);
            setStartDateWarranty(data.warranty_start ? moment(data.warranty_start) : null);
            setEndDateWarranty(data.warranty_end ? moment(data.warranty_end) : null);
            setInvoiceDue(data.invoice_date ? moment(data.invoice_date) : null);
            setAmount(Number(data.invoice_amount));
            setParentMaintenance(data);
            setInstallationDate(selected.installation_date ? moment(selected.installation_date) : null);
            setSerialNumber(selected.serial_number);
            setRouterInfo(selected.router_info);
        })
    }

    const active = (a, b) => {
        const active = moment().isBetween(moment(a), moment(b), null, '[]')  || moment().isBefore(moment(a));
        const expiring = moment().isBetween(moment(b).subtract(1, 'month'), moment(b), null, '[]');
        const extended = moment(b).diff(moment(a), 'years') > 1;
        if(expiring)
            return t("Expiring");

        if(extended)
            return t("Extended");

        if(active)
            return t("Active");

        return t("Expired");
    }

    const compareData = () => {
        const selected = props.selectedDevice || {};
        const selectedData = {
            'period_start': selected.parent_maintenance?.period_start ? selected.parent_maintenance.period_start : selected.period_start,
            'period_end': selected.parent_maintenance?.period_end ? selected.parent_maintenance.period_end : selected.period_end,
            'invoice_amount': selected.parent_maintenance?.invoice_amount ? Number(selected.parent_maintenance.invoice_amount) : Number(selected.invoice_amount) || 0,
            'invoice_date': selected.parent_maintenance?.invoice_date ? selected.parent_maintenance.invoice_date : selected.invoice_date,
            'warranty_end': selected.parent_maintenance?.warranty_end ? selected.parent_maintenance.warranty_end : selected.warranty_end,
            'warranty_start': selected.parent_maintenance?.warranty_start ? selected.parent_maintenance.warranty_start : selected.warranty_start,
            'parent_maintenance_id': selected.parent_maintenance_id,
            'installation_date': selected.installation_date,
            'serial_number': selected.serial_number,
            'router_info': selected.router_info
        }
        // if(startDate === null || endDate === null || startDateWarranty === null || endDateWarranty === null || invoiceDue === null)
        //     return true;

        const data = {
            'period_start': startDate?.format("YYYY-MM-DD") || null,
            'period_end': endDate?.format("YYYY-MM-DD") || null,
            'invoice_amount': amount,
            'invoice_date': invoiceDue?.format("YYYY-MM-DD") || null,
            'warranty_end': endDateWarranty?.format("YYYY-MM-DD") || null,
            'warranty_start': startDateWarranty?.format("YYYY-MM-DD") || null,
            'parent_maintenance_id': parentMaintenanceId,
            'installation_date': installationDate?.format("YYYY-MM-DD") || null,
            'serial_number': serialNumber,
            'router_info': routerInfo
        }

        return lodash.isEqual(selectedData, data);
    }

    const confirmDisable = (enable) => {
        confirmationMessage.fire({
            title: t("Are you sure?"),
            text: t(""),
            icon: "warning",
            showCancelButton: true,
        })
            .then((result) => {
                if(result.isConfirmed) {
                    dispatch(enableLoading());

                    const data = {
                        'maintenance_disabled': enable ? 0 : 1
                    }

                    UpdateMaintenance(props.selectedDevice.id, data).then((response) => {
                        dispatch(disableLoading());

                        if (response.status !== 200 && response.status !== 201) {
                            let message = response.response.data?.message;
                            if (message === "Validation error") {
                                let data = response.response.data.data;

                                message = "";

                                for (const [, value] of Object.entries(data)) {
                                    message = message + value[0] + "<br/>";
                                }
                            }

                            errorMessage.fire({
                                title: <strong>Error!</strong>, html: message, icon: 'error'
                            }).then();
                        } else {
                            cleanAndCloseModal(true, true, true);
                        }
                    }).catch((error) => {
                        dispatch(disableLoading());
                        errorMessage.fire({
                            title: <strong>Error!</strong>, html: error.message || "An error occurred", icon: 'error'
                        }).then();
                    });
                }
            });
    }

    const confirmSave = () => {
        confirmationMessage.fire({
            title: t("Are you sure?"),
            text: t(""),
            icon: "warning",
            showCancelButton: true,
        })
        .then((result) => {
            if(result.isConfirmed) {
                dispatch(enableLoading());

                const data = {
                    'period_start': startDate?.format("YYYY-MM-DD") || null,
                    'period_end': endDate?.format("YYYY-MM-DD") || null,
                    'invoice_amount': amount,
                    'invoice_date': invoiceDue?.format("YYYY-MM-DD") || null,
                    'warranty_start': startDateWarranty?.format("YYYY-MM-DD") || null,
                    'warranty_end': endDateWarranty?.format("YYYY-MM-DD") || null,
                    'parent_maintenance_id': parentMaintenanceId,
                    'parent_maintenance': parentMaintenance,
                    'installation_date': installationDate?.format("YYYY-MM-DD") || null,
                    'serial_number': serialNumber,
                    'router_info': routerInfo
                }

                UpdateMaintenance(props.selectedDevice.id, data).then((response) => {
                    dispatch(disableLoading());

                    if (response.status !== 200 && response.status !== 201) {
                        let message = response.response.data?.message;
                        if (message === "Validation error") {
                            let data = response.response.data.data;

                            message = "";

                            for (const [, value] of Object.entries(data)) {
                                message = message + value[0] + "<br/>";
                            }
                        }

                        errorMessage.fire({
                            title: <strong>Error!</strong>, html: message, icon: 'error'
                        }).then();
                    } else {
                        cleanAndCloseModal(true, true, true);
                    }
                }).catch((error) => {
                    dispatch(disableLoading());
                    errorMessage.fire({
                        title: <strong>Error!</strong>, html: error.message || "An error occurred", icon: 'error'
                    }).then();
                });
            }
        });
    }

    useEffect(() => {
        const selected = props.selectedDevice || {};
        setParentMaintenance(selected.parent_maintenance);
        setParentMaintenanceId(selected.parent_maintenance_id);
        setDisableMaintenance(selected.maintenance_disabled !== 0);
        if(selected.parent_maintenance) {
            const parent = selected.parent_maintenance;
            setStartDate(parent.period_start ? moment(parent.period_start) : null);
            setEndDate(parent.period_end ? moment(parent.period_end) : null);
            setStartDateWarranty(parent.warranty_start ? moment(parent.warranty_start) : null);
            setEndDateWarranty(parent.warranty_end ? moment(parent.warranty_end) : null);
            setInvoiceDue(parent.invoice_date ? moment(parent.invoice_date) : null);
            setAmount(Number(parent.invoice_amount));
        } else {
            setStartDate(selected.period_start ? moment(selected.period_start) : null);
            setEndDate(selected.period_end ? moment(selected.period_end) : null);
            setStartDateWarranty(selected.warranty_start ? moment(selected.warranty_start) : null);
            setEndDateWarranty(selected.warranty_end ? moment(selected.warranty_end) : null);
            setInvoiceDue(selected.invoice_date ? moment(selected.invoice_date) : null);
            setAmount(Number(selected.invoice_amount));
        }

        setInstallationDate(selected.installation_date ? moment(selected.installation_date) : null);
        setSerialNumber(selected.serial_number);
        setRouterInfo(selected.router_info);
    }, [props.selectedDevice]);

    return (<>
    {currentUser && currentGroup.id === 1 ? (
        <Modal {...props} size="lg">
            <Modal.Header>
                {props.selectedDevice && <Modal.Title>{props.selectedDevice.name} <span className="text-muted fw-normal">— {t("Maintenance")}</span></Modal.Title> }
            </Modal.Header>
            <Modal.Body>
                {!disableMaintenance && <Form>
                    <div className="mm-section-title">{t("Maintenance")}</div>
                    <div className="mm-grid">
                        <div className="mm-row">
                            <div className="mm-label">{t("Linked maintenance")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1) ? <Form.Select value={parentMaintenanceId ?? "0"} onChange={handleParentChange} disabled={currentUser && currentGroup.id !== 1}>
                                    <option value="0">{t("-")}</option>
                                    {props.devices && props.devices.map((device) => {
                                        if(device.id === props.selectedDevice?.id)
                                            return;

                                        return <option key={device.id} value={device.id}>{device.name}</option>
                                    })}
                                </Form.Select> : <span className="form-control mm-trigger">{formatDateRange(startDate, endDate)}</span>}
                            </div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Status")}</div>
                            <div className="mm-value"><span className={badgeClassForStatus(active(startDate, endDate))}>{active(startDate, endDate)}</span></div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Period")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1 && parentMaintenanceId === null) ? <DateRangePicker
                                    initialSettings={{
                                        startDate: startDate ? startDate.toDate() : moment().toDate(),
                                        endDate: endDate ? endDate.toDate() : moment().toDate(),
                                    }}
                                    onEvent={(e, picker) => {
                                        handleCallback(picker.startDate, picker.endDate);
                                    }}
                                >
                                    <span className="form-control mm-trigger">{formatDateRange(startDate, endDate)}</span>
                                </DateRangePicker> : <span className="form-control mm-trigger">{formatDateRange(startDate, endDate)}</span>}
                            </div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Invoice due")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1 && parentMaintenanceId === null) ? <DateRangePicker
                                    initialSettings={{
                                        startDate: invoiceDue ? invoiceDue.toDate() : moment().toDate(),
                                        singleDatePicker: true,
                                    }}
                                    onEvent={(e, picker) => {
                                        handleCallbackDue(picker.startDate);
                                    }}
                                >
                                    <span className="form-control mm-trigger">{formatDate(invoiceDue)}</span>
                                </DateRangePicker> : <span className="form-control mm-trigger">{formatDate(invoiceDue)}</span>}
                            </div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Invoice amount")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1 && parentMaintenanceId === null) ? <Form.Control
                                    type="number"
                                    value={amount.toFixed(2)}
                                    onChange={handleInvoiceAmountChange}
                                    readOnly={currentUser && currentGroup.id !== 1}
                                /> : <span className="form-control mm-trigger">{amount.toFixed(2)}</span>}
                            </div>
                        </div>
                    </div>

                    <div className="mm-section-title">{t("Warranty")}</div>
                    <div className="mm-grid">
                        <div className="mm-row">
                            <div className="mm-label">{t("Status")}</div>
                            <div className="mm-value"><span className={badgeClassForStatus(active(startDateWarranty, endDateWarranty))}>{active(startDateWarranty, endDateWarranty)}</span></div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Warranty period")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1 && parentMaintenanceId === null) ? <DateRangePicker
                                    initialSettings={{
                                        startDate: startDateWarranty ? startDateWarranty.toDate() : moment().toDate(),
                                        endDate: endDateWarranty ? endDateWarranty.toDate() : moment().toDate(),
                                    }}
                                    onEvent={(e, picker) => {
                                        handleCallbackWarranty(picker.startDate, picker.endDate);
                                    }}
                                >
                                    <span className="form-control mm-trigger">{formatDateRange(startDateWarranty, endDateWarranty)}</span>
                                </DateRangePicker> : <span className="form-control mm-trigger">{formatDateRange(startDateWarranty, endDateWarranty)}</span>}
                            </div>
                        </div>
                    </div>

                    <div className="mm-section-title">{t("Device details")}</div>
                    <div className="mm-grid">
                        <div className="mm-row">
                            <div className="mm-label">{t("Installation date")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1) ? <DateRangePicker
                                    initialSettings={{
                                        startDate: installationDate ? installationDate.toDate() : moment().toDate(),
                                        singleDatePicker: true,
                                    }}
                                    onEvent={(e, picker) => {
                                        handleCallbackInstallation(picker.startDate);
                                    }}
                                >
                                    <span className="form-control mm-trigger">{formatDate(installationDate)}</span>
                                </DateRangePicker> : <span className="form-control mm-trigger">{formatDate(installationDate)}</span>}
                            </div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Serial number")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1) ? <Form.Control
                                    type="text"
                                    value={serialNumber}
                                    onChange={handleSerialNumberChange}
                                    readOnly={currentUser && currentGroup.id !== 1}
                                /> : <span className="form-control mm-trigger">{serialNumber}</span>}
                            </div>
                        </div>
                        <div className="mm-row">
                            <div className="mm-label">{t("Router info")}</div>
                            <div className="mm-value">
                                {(currentUser && currentGroup.id === 1) ? <Form.Control
                                    type="text"
                                    value={routerInfo}
                                    onChange={handleRouterInfoChange}
                                    readOnly={currentUser && currentGroup.id !== 1}
                                /> : <span className="form-control mm-trigger">{routerInfo}</span>}
                            </div>
                        </div>
                    </div>
                </Form>}
            </Modal.Body>
            <Modal.Footer>
                <div className="mm-footer-left">
                    <Button size="sm" variant={!disableMaintenance ? "outline-danger" : "outline-success"} onClick={() => confirmDisable(disableMaintenance)}>
                        {!disableMaintenance ? t("Disable maintenance fee") : t("Enable maintenance fee")}
                    </Button>
                    {!disableMaintenance && (
                    <Button size="sm" variant="outline-secondary" onClick={() => cleanAndCloseModal(false, true, false)}>
                        {t("Clear")}
                    </Button>)}
                </div>
                <Button variant="secondary" onClick={() => cleanAndCloseModal()}>
                    {t("Close")}
                </Button>
                {!compareData() && <Button variant="primary" onClick={() => {
                    confirmSave();
                }}>
                        {t("Save")}
                    </Button>}
            </Modal.Footer>
        </Modal>
    ) : (

        <Modal {...props} size="lg">
            <Modal.Header>
                {props.selectedDevice && <Modal.Title>{props.selectedDevice.name} <span className="text-muted fw-normal">— {t("Maintenance")}</span></Modal.Title> }
            </Modal.Header>
            <Modal.Body>
                {!disableMaintenance && <div className="mm-grid">
                    <div className="mm-row">
                        <div className="mm-label">{t("Maintenance status")}</div>
                        <div className="mm-value"><span className={badgeClassForStatus(active(startDate, endDate))}>{active(startDate, endDate)}</span></div>
                    </div>
                    <div className="mm-row">
                        <div className="mm-label">{t("Maintenance period")}</div>
                        <div className="mm-value">{formatDateRange(startDate, endDate)}</div>
                    </div>
                    <div className="mm-row">
                        <div className="mm-label">{t("Warranty")}</div>
                        <div className="mm-value"><span className={badgeClassForStatus(active(startDateWarranty, endDateWarranty))}>{active(startDateWarranty, endDateWarranty)}</span></div>
                    </div>
                    <div className="mm-row">
                        <div className="mm-label">{t("Warranty period")}</div>
                        <div className="mm-value">{formatDateRange(startDateWarranty, endDateWarranty)}</div>
                    </div>
                </div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => cleanAndCloseModal()}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>

    )}
    </>);
}
